import axios from "axios";
import { SERVER_URL } from "../config";

export const fetchGodowns = async () => {
  try {
    const res = await axios.get(`${SERVER_URL}/centralLocationStock.php`, {
      params: { action: "godowns" },
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching godowns:", err);
    return [];
  }
};

export const fetchProducts = async () => {
  try {
    const res = await axios.get(`${SERVER_URL}/centralLocationStock.php`, {
      params: { action: "products" },
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching products:", err);
    return [];
  }
};

export const fetchStockReport = async (godowns = [], products = []) => {
  try {
    // Convert arrays to comma-separated strings for the API
    const godownStr = Array.isArray(godowns) ? godowns.join(',') : '';
    const productStr = Array.isArray(products) ? products.join(',') : '';
    
    const res = await axios.get(`${SERVER_URL}/centralLocationStock.php`, {
      params: {
        action: "stock_report",
        godown: godownStr,
        product: productStr,
      },
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching stock report:", err);
    return [];
  }
};